export default "__VITE_ASSET__P2r5oRH3__"